export enum TabEnum {
  Ventas = 1,
  Cajas,
  Clientes,
  Compras,
  Almacen,
  Seguridad
}
